'use strict';

var ChartSponsorForecastDirective = function ChartSponsorForecastDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-sponsor-forecast.html'),
    controller: 'ChartSponsorForecastController',
    scope: {
      market: '=',
      wizardMode: '=',
      flight: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.viewportFormatters);
      scope.renderChartDataPresent = function renderChart(data, selectionSize) {
        if (element.is(':visible')) {
          chart.withMetric(scope.selectedMetric).render(data);
          viewport.render(data, selectionSize);
        }
      };
      viewport.on('rangechange', function (range) {
        chart.domainChange(range);
      });
      element.closest('.collapse').on('hidden.bs.collapse', scope.hidePanels).on('shown.bs.collapse', function () {
        scope.hidePanels();
        scope.initChart();
      });
      scope.$watch('market', function () {
        if (element.is(':visible') && scope.market) {
          scope.initChart();
        }
      });
      scope.$watch('flight', function () {
        if (element.is(':visible') && scope.flight) {
          scope.initChart();
        }
      });
    }
  };
};
ChartSponsorForecastDirective.$inject = ['ChartSponsorForecast', 'ChartSponsorForecastViewport'];
module.exports = ChartSponsorForecastDirective;